"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importDefault(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const SupportMenu = ({ type, messageType, setMessageType, resetSupportMessage, }) => (react_1.default.createElement("div", { className: styles_scss_1.default.contentPaperItem },
    react_1.default.createElement("h4", null, constants_1.default.support.title[type]),
    react_1.default.createElement("p", null, constants_1.default.support.pleaseContact[type]),
    react_1.default.createElement(components_1.Button, { title: constants_1.default.support.sendAMessage, ariaLabel: constants_1.default.support.sendAMessage, variant: "ghost", onClick: () => {
            if (messageType) {
                setMessageType(null);
                resetSupportMessage();
                // Timeout for animation purposes
                setTimeout(() => {
                    setMessageType(type);
                }, 100);
            }
            else {
                setMessageType(type);
            }
        } })));
exports.default = SupportMenu;
